import { createCanBoundTo } from "@casl/react";
import { ability } from "./config/ability";

// Impements https://casl.js.org/v5/en/package/casl-react#can-component

export const Can = createCanBoundTo(ability);
